import type { SheetTemplateInstance } from "building-types/views/planSets";
import { constructSheetTitleNumber } from "common/utils/constructSheetTitleNumber";
import type { SheetTitle } from "lib/house/plans/sheetInfo";

export function constructSheetTitle(instance: SheetTemplateInstance): SheetTitle {
  return {
    name: instance.name,
    number: constructSheetTitleNumber(instance.sheetNumberPrefix, instance.sheetNumber),
  };
}
